import {DomainError} from "@web-libs/core/shared-domain/shared-domain.errors";

export class InformationForbiddenError extends DomainError{
    constructor(message = "The information is forbidden for the current user.") {
        super(message);
        this.name = 'InformationForbiddenError';
        Object.setPrototypeOf(this, InformationForbiddenError.prototype);
    }
}
